import {useState, useEffect} from "react";
import {Navbar, Container, Nav} from "react-bootstrap"

import logo from '../assets/logo.png'
import linkedinIcon from '../assets/linkedin-icon.svg'
import githubIcon from '../assets/github-icon.svg'
import youtubeIcon from '../assets/youtube-icon.svg'
import {Link} from "react-scroll";

export const NavBar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [activeLink, setActiveLink] = useState(null);

    useEffect(() => {
        const onScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        }
        window.addEventListener("scroll", onScroll);

        return () => window.removeEventListener("scroll", onScroll);
    }, [])
    
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
            <Container fluid className="navbar-container">
                <div className="navbar-inner">
                <Navbar.Brand className="navbar-brand" as={Link} to="home" smooth={true} duration={500} offset={-50} style={{cursor: 'pointer'}}>
                    <img src={logo} alt="logo"/>
                </Navbar.Brand>

                <div className="navbar-links-center">
                    <Nav className="navbar-nav">
                        <Nav.Link as={Link} to="experience" smooth={true} duration={500} offset={-50} className={activeLink === 'experience' ? 'active navbar-link' : 'navbar-link'} onClick={() => setActiveLink('experience')}>Experience</Nav.Link>
                        <Nav.Link as={Link} to="publications" smooth={true} duration={500} offset={-50} className={activeLink === 'publications' ? 'active navbar-link' : 'navbar-link'} onClick={() => setActiveLink('publications')}>Publications</Nav.Link>
                        <Nav.Link as={Link} to="presentations" smooth={true} duration={500} offset={-50} className={activeLink === 'presentations' ? 'active navbar-link' : 'navbar-link'} onClick={() => setActiveLink('presentations')}>Presentations</Nav.Link>
                        <Nav.Link as={Link} to="skills" smooth={true} duration={500} offset={-50} className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} onClick={() => setActiveLink('skills')}>Skills</Nav.Link>
                    </Nav>
                </div>

                <div className="navbar-right">
                    <div className="social-icon">
                    <a href="https://www.linkedin.com/in/shannonjliu/" target="_blank"><img src={linkedinIcon} alt="LinkedIn"/></a>
                    <a href="https://github.com/shannon-jliu" target="_blank"><img src={githubIcon} alt="GitHub"/></a>
                    <a href="https://www.youtube.com/@JerseyDrone" target="_blank"><img src={youtubeIcon} alt="YouTube"/></a>
                    </div>
                </div>
                </div>
            </Container>
        </Navbar>
    )
}

